<template>
  <ai-customer-iframe type="link" />
</template>

<script>
import AiCustomerIframe from './ai-customer-iframe.vue'

export default {
  name: 'ai-customer-link',
  components: { AiCustomerIframe },
}
</script>
